import { Link } from 'react-router-dom';
import { allGenres } from '@/utils/movie';

const socials = [
  { icon: 'ri-weibo-fill', label: '微博', href: '#' },
  { icon: 'ri-wechat-fill', label: '微信', href: '#' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩', href: '#' },
  { icon: 'ri-douban-line', label: '豆瓣', href: '#' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-950 text-secondary-100">
      <div className="container-page py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-foreground-950">
                <i className="ri-film-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-extrabold text-secondary-50">免费看大片</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-300">
              汇聚海量热门大片与经典影片，提供影片资讯、分类筛选与个性化推荐，让每一位影迷都能快速找到想看的好电影。
            </p>
            <div className="mt-5 flex gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-lg text-secondary-100 transition-colors hover:bg-primary-500 hover:text-foreground-950"
                >
                  <i className={s.icon} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-secondary-50">
              <span className="cursor-default">热门分类</span>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              {allGenres.slice(0, 8).map((g) => (
                <li key={g.key}>
                  <Link to={`/category/${g.key}`} className="text-secondary-300 transition-colors hover:text-primary-400">
                    {g.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-secondary-50">
              <span className="cursor-default">快速导航</span>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-secondary-300 transition-colors hover:text-primary-400">首页</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-secondary-300 transition-colors hover:text-primary-400">电影分类</Link>
              </li>
              <li>
                <Link to="/search" className="text-secondary-300 transition-colors hover:text-primary-400">搜索影片</Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 transition-colors hover:text-primary-400">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-secondary-50">
              <span className="cursor-default">观影提示</span>
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              本站影片资源仅为前端演示用途，播放功能暂未接入真实视频接口，影片信息均为虚构示例，请以正式版权平台内容为准。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-sm text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 免费看大片 · 影视内容演示站 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-information-line" aria-hidden="true" />
            本站内容仅供学习与演示使用
          </p>
        </div>
      </div>
    </footer>
  );
}